import React, { useState, useEffect } from 'react'
import styles from './index.module.scss'
import cn from 'classnames'
import PropTypes from 'prop-types'
import { INVOICE_STATUSES } from '../../../utilities/constants'
import DatePicker from 'react-datepicker'
import dayjs from 'dayjs'
import UnderlineSelect from '../../underline-select'

function ARFilterForm ({ handleInputChange, initialValues, clearSearch, options, showOptions }) {
  const [formValues, setFormValues] = useState(initialValues)
  const [isError, setIsError] = useState(false)

  useEffect(() => {
    if (isError) {
      setTimeout(() => {
        setIsError(false)
      }, [5000])
    }
  }, [isError])

  const handleInputChangeWrapper = (newValues) => {
    setIsError(false)
    setFormValues((prevValues) => ({
      ...prevValues,
      ...newValues
    }))
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    handleInputChange(formValues)
  }

  const handleClear = () => {
    let tempVals = {}
    Object.entries(initialValues || {}).forEach(([key, value]) => {
      tempVals = {
        ...tempVals,
        [key]: (Array.isArray(value) ? [] : '')
      }
    })
    setFormValues(tempVals)
    clearSearch()
  }
  const statusOptions = [
    { value: INVOICE_STATUSES.OPEN, label: 'Open' },
    { value: INVOICE_STATUSES.OVERDUE, label: 'Overdue' },
    { value: INVOICE_STATUSES.PAID, label: 'Paid' },
    { value: INVOICE_STATUSES.CLOSED_IN_QBO, label: 'Closed in QBO' }
  ]

  function formatDate (date) {
    const dateSplit = (date).split('-')
    const dateYear = parseInt(dateSplit[0])
    const dateMonth = parseInt(dateSplit[1] - 1)
    const dateDay = parseInt(dateSplit[2])
    return new Date(dateYear, dateMonth, dateDay).toUTCString()
  }

  return (
    <div className={styles.searchContainer}>
      <div className={styles.panel}>
        <form className={styles.form}>
          <div className={styles.inputs}>
            {
              showOptions?.includes('dateRange') && (
                <>
                  <label className={cn(styles.label, 'control-label', styles.dateInput)} htmlFor='createdFrom'>
                    Start Date
                    <DatePicker
                      name='startDate'
                      disabled={formValues?.years?.length > 0 || formValues?.yearToDate?.length > 0}
                      dateFormat='MM/dd/yyyy'
                      selected={formValues?.startDate ? new Date(formatDate(formValues.startDate)) : undefined}
                      maxDate={formValues?.endDate ? new Date(formatDate(formValues.endDate)) : undefined}
                      onChange={(date) => {
                        if (date) {
                          handleInputChangeWrapper({
                            startDate: dayjs(date).format('YYYY-MM-DD')
                          })
                        }
                      }}
                    />
                  </label>
                  <label className={cn(styles.label, 'control-label', styles.dateInput)} htmlFor='createdTo'>
                    End Date
                    <DatePicker
                      name='endDate'
                      disabled={formValues?.years?.length > 0 || formValues?.yearToDate?.length > 0}
                      dateFormat='MM/dd/yyyy'
                      selected={formValues?.endDate ? new Date(formatDate(formValues.endDate)) : undefined}
                      minDate={formValues?.startDate ? new Date(formatDate(formValues.startDate)) : undefined}
                      onChange={(date) => {
                        if (date) {
                          handleInputChangeWrapper({
                            endDate: dayjs(date).format('YYYY-MM-DD')
                          })
                        }
                      }}
                    />
                  </label>
                </>
              )
            }
            {
              showOptions?.includes('status') && (
                <div>
                  <label className={cn(styles.label, styles.border)} htmlFor='status'>
                    <div>Status</div>
                    <UnderlineSelect
                      placeholder={''}
                      isMulti
                      enableSelectAll
                      options={statusOptions}
                      defaultValue={formValues?.status ? formValues?.status?.map(id => statusOptions.find(opt => opt.value === id)).filter(Boolean) : []}
                      onChange={(selectedOptions) => {
                        const selectedValues = selectedOptions?.map(option => option.value) || []
                        handleInputChangeWrapper({ status: selectedValues })
                      }}
                    />
                  </label>
                </div>
              )
            }
            {
              showOptions?.includes('collectors') && (
                <div>
                  <label className={cn(styles.label, styles.border)} htmlFor='collectors'>
                    <div>Collector</div>
                    <UnderlineSelect
                      placeholder={''}
                      isMulti
                      isSearchable
                      enableSelectAll
                      options={options?.collectors}
                      defaultValue={formValues?.collectors ? formValues?.collectors?.map(id => options?.collectors.find(opt => opt.value === id)).filter(Boolean) : []}
                      onChange={(selectedOptions) => {
                        const selectedValues = selectedOptions?.map(option => option.value) || []
                        handleInputChangeWrapper({ collectors: selectedValues })
                      }}
                    />
                  </label>
                </div>
              )
            }
            {
              showOptions?.includes('accounts') && (
                <div>
                  <label className={cn(styles.label, styles.border)} htmlFor='accounts'>
                    <div>Account Name</div>
                    <UnderlineSelect
                      placeholder={''}
                      isMulti
                      isSearchable
                      options={options?.accounts}
                      defaultValue={formValues?.accounts ? formValues?.accounts?.map(id => options?.accounts.find(opt => opt.value === id)).filter(Boolean) : []}
                      onChange={(selectedOptions) => {
                        const selectedValues = selectedOptions?.map(option => option.value) || []
                        selectedValues.length <= 5 ? handleInputChangeWrapper({ accounts: selectedValues }) : setIsError(true)
                      }}
                      isError={isError}
                    />
                  </label>
                  {isError && <label htmlFor='accounts' className={styles.errorMessage}>You can select up to 5 accounts only.</label>}
                </div>
              )
            }
          </div>
          <div className={styles.btns}>
            <div>
              <button
                type='submit'
                onClick={handleSubmit}
                className='dis-btn dis-btn-sm dis-btn-success'>
                Search
                <i className='material-icons dis-btn-icon'>search</i>
              </button>
              <button
                type='button'
                onClick={handleClear}
                className={cn(styles.clearBtn, 'dis-btn dis-btn-white dis-btn-sm')}>
                Clear
                <i className='material-icons dis-btn-icon'>clear</i>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  )
}

ARFilterForm.propTypes = {
  handleInputChange: PropTypes.func.isRequired,
  initialValues: PropTypes.any,
  clearSearch: PropTypes.func,
  showOptions: PropTypes.arrayOf(PropTypes.oneOf(['years', 'months', 'collectors', 'accounts'])),
  options: PropTypes.shape({
    collectors: PropTypes.array,
    accounts: PropTypes.array
  })
}

export default ARFilterForm
